import React ,{ useRef, useLayoutEffect, useState,useEffect }from 'react';
import { withRouter } from 'react-router-dom';
import { color, COLORS } from 'html2canvas/dist/types/css/types/color';
import { Gradient } from '@material-ui/icons';
import { withWidth } from '@material-ui/core';
import annotationPlugin from 'chartjs-plugin-annotation'
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController
} from "chart.js";
  import { Chart } from "react-chartjs-2";
  import faker from "faker";
  ChartJS.register(
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
    annotationPlugin
  );
  
function Observationchart() {

  const labels = ["January", "February", "March", "April", "May", "June", "July"];
  const options = {
    responsive: true,
    //maintainAspectRatio: false,
    scales: {
      y: {
      max: 1,
      min: 0,
      ticks: {
          stepSize:1 ,
          display: false
       },
       font: {
        size: 12,
        weight: 'bold',
      },
      lineHeight: 2, // Adjust the line height of the y-axis points
      },
      x: {  
        ticks: {
            display: false
         },
        }
    },
    plugins: {
      legend: {
        display: false
      },
      annotation: {
        annotations: [
          {
            type: "box" as const, // important, otherwise typescript complains
            ScaleID: "y-axis-0",
            yMin:0,
            yMax: 1,
            borderColor: "black",
            borderWidth: 0,
            backgroundColor: '#e8eaec', 
            drawTime: "beforeDraw",  

          }
        ]
      }
    }
  };
 const data = {
    labels,
    datasets: [
      {
        type: "line" as const,
        label: "",
        borderColor: "rgb(25, 99, 132)",
        borderWidth: 2,
        fill: false,
        data: [20, 40, 30, 35, 30, 20],
      },
      {
        type: "bar" as const,
        label: "Dataset 2",
        backgroundColor: "",
        data: labels.map(() => faker.datatype.number({ min: 0, max: 1 })),
        borderColor: "white",
        borderWidth: 2,
        drawTime: "beforeDatasetDraw",
        hidden: true
      }
    ]
  };
  const [width, setWidth] = useState(0);
  const elementRef = useRef(null);

  React.useEffect(() => {
    const element = document.getElementById('myElement') as HTMLElement;
    if (element) {
      const width = element.clientWidth;
      // Use the width variable here
    }
  }, []);
 return (
  
  <div style={{height:'30px',width:'500px'}} id="myElement">
     {/*
    // @ts-ignore */}
    <Chart  style={{height:'30px !important',width:'500px'}} type="bar" options={options} data={data} />;
 </div>
 );
};

export default React.memo(withRouter(Observationchart));







